// extracted by mini-css-extract-plugin
export default {"innerContainer":"TestingSchedulePage_innerContainer__nR1Bj","testItem":"TestingSchedulePage_testItem__-pfBZ","desctiption":"TestingSchedulePage_desctiption__SLwwa"};